import { Box } from '@factorialco/deprecated-design-system'

interface ModalHeaderProps {
  title?: string
  imageUrl?: string
}

const ModalHeader = ({ imageUrl }: ModalHeaderProps) => (
  <Box padding="s16">
    <Box flexDirection="row" gap="s16">
      <Box justifyContent="center">
        <img
          src={imageUrl}
          alt="Recruitment"
          style={{
            width: '300px',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '20px',
          }}
        />
      </Box>
    </Box>
  </Box>
)

export default ModalHeader
